module.exports = __webpack_public_path__ + "static/news67.png";